import { AutoOrManualInterface } from 'store/reducers/visualisations/types';

export const autoOrManualOptions: { label: string; value: AutoOrManualInterface['type'] }[] = [
  { value: 'auto', label: 'Авто' },
  { value: 'manual', label: 'Вручную' },
];
